module.exports = __webpack_public_path__ + "img/logo_GR3x.afd06eef.png";